var map = {
	"./lg-gray-bootstrap.svg": 129,
	"./lg-gray-css.svg": 342,
	"./lg-gray-figma.svg": 472,
	"./lg-gray-fluig.svg": 748,
	"./lg-gray-github.svg": 4,
	"./lg-gray-html.svg": 142,
	"./lg-gray-jquery.svg": 767,
	"./lg-gray-js.svg": 876,
	"./lg-gray-mongo.svg": 647,
	"./lg-gray-node.svg": 13,
	"./lg-gray-php.svg": 47,
	"./lg-gray-postman.svg": 65,
	"./lg-gray-react.svg": 710,
	"./lg-gray-sass.svg": 415,
	"./lg-gray-sql.svg": 59,
	"./lg-gray-totvs.svg": 703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 900;